import {
  AngularComponentsModule,
  GoabTable,
  GoabTableOnSortDetail,
  GoabTableSortHeader,
} from '@abgov/angular-components';
import { DateTransform, ResourcePipe } from '@ala/common-ui';
import { CommonModule } from '@angular/common';
import { BadgeTransformPipe } from '../../../../shared/pipes/badge-transform.pipe';

import { Component, CUSTOM_ELEMENTS_SCHEMA, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificationService } from '@libs/services/notification.service';
import { CapacityReportListStateService } from '../../../../services-v2/states/capacity-report-list.state.service';
import { EnumReverseMappingPipe } from '../../../../shared/pipes/enum-reverse-mapping.pipe';
import { CapacityReportingPagination } from '../capacity-reporting-pagination/capacity-reporting-pagination';
@Component({
  selector: 'app-capacity-reporting-grid',
  imports: [
    CommonModule,
    AngularComponentsModule,
    GoabTable,
    GoabTableSortHeader,
    DateTransform,
    ResourcePipe,
    EnumReverseMappingPipe,
    BadgeTransformPipe,
    CapacityReportingPagination,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './capacity-reporting-grid.html',
  styleUrl: './capacity-reporting-grid.scss',
})
export class CapacityReportingGrid {
  public pageId = 'VIEWENTRIES';
  private readonly _capacityReportState = inject(
    CapacityReportListStateService
  );
  private readonly _notificationService = inject(NotificationService);
  router = inject(Router);
  route = inject(ActivatedRoute);

  userFacility = this._capacityReportState.filteredCapacityReports;
  sort = this._capacityReportState.sort;
  page = this._capacityReportState.page;
  tab = this._capacityReportState.tab;

  async tableOnSort($event: GoabTableOnSortDetail) {
    const sortOrder = $event.sortBy;
    if (sortOrder) {
      this._notificationService.progressIndicatorMessage.set(
        'Loading capacity reports...'
      );
      this._notificationService.isProgressIndicator.set(true);
      this._capacityReportState.setSortOrder = {
        [sortOrder]: $event.sortDir === 1 ? 'asc' : 'desc',
      };
      await this._capacityReportState.loadCapacityReports();
      this._notificationService.isProgressIndicator.set(false);
    }
  }

  onFacilityClick(facilityId: string) {
    this.router.navigate([facilityId, 'edit'], { relativeTo: this.route });
  }
}
